import React from 'react';
const points = [{
  num: '01',
  title: 'Domingo por la tarde = Ansiedad.',
  desc: 'Sacrificas el descanso de tu fin de semana buscando qué rutinas dar el lunes para no repetir lo mismo.'
}, {
  num: '02',
  title: 'El trabajo no termina nunca.',
  desc: 'Después de horas corrigiendo posturas, llegas a casa con la carga mental de preparar la mañana siguiente.'
}, {
  num: '03',
  title: 'Alumnas que "se estancan".',
  desc: 'Sientes que te faltan herramientas para que vean resultados reales en su postura y flexibilidad.'
}, {
  num: '04',
  title: 'Buscas reconocimiento.',
  desc: 'Quieres ser la instructora que presenta un programa riguroso, moderno y de excelencia en su Studio.'
}];
export function ForWhomSection() {
  return <section className="w-full bg-bg-dark py-20 px-4 relative overflow-hidden" data-id="element-132">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary/10 rounded-full blur-[100px] pointer-events-none" data-id="element-133"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-134">
        <div className="text-center mb-12" data-id="element-135">
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-136">
            👀 ¿Reconoces estas escenas?
          </h2>
          <p className="text-text-sec text-base sm:text-lg" data-id="element-137">
            Megapack Pilates Listo es para ti si vives esto:
          </p>
        </div>

        <div className="space-y-4" data-id="element-138">
          {points.map((point, i) => <div key={i} className="flex items-start gap-5 bg-bg-alt/80 backdrop-blur-sm rounded-2xl p-6 border border-border-light hover:border-primary/50 transition-colors group shadow-lg" data-id="element-139">
              <span className="text-primary font-black text-2xl sm:text-3xl flex-shrink-0 leading-none mt-0.5" data-id="element-140">
                {point.num}
              </span>
              <div data-id="element-141">
                <h3 className="text-text-main text-lg sm:text-xl font-bold mb-1.5" data-id="element-142">
                  {point.title}
                </h3>
                <p className="text-text-sec text-base font-medium leading-relaxed" data-id="element-143">
                  {point.desc}
                </p>
              </div>
            </div>)}
        </div>

        <p className="text-center text-text-main font-bold text-lg sm:text-xl mt-10" data-id="element-144">
          ✋ ¿Te has reconocido?{' '}
          <span className="text-primary" data-id="element-145">
            Entonces este Kit es exactamente para ti.
          </span>
        </p>
      </div>
    </section>;
}